import { useEffect, useRef } from 'react';
import Message from "@/components/Message/index";
import { PAGInit } from 'libpag';
import BigNumber from "bignumber.js";

export const newPath = ''
export const dmailAi = "@dmail.ai";

export const EmailHost = 'https://mail.dmail.ai'
export const SubhubHost = 'https://dmailnetwork.gitbook.io/dmail-network/products/subscription-hub'
export const EmailLink = `${EmailHost}/inbox`
export const NFTsLink = 'https://yuku.app/market/nusra-3iaaa-aaaah-qc2ta-cai'
export const LiepaperLink = 'https://dmail.ai/Dmail_litepaper.pdf'
export const GitLink = 'https://github.com/dmailofficial/dmail'
export const DocsLink = 'https://dmailofficial.gitbook.io/helpcenter/v/english/'
export const SubLink = 'https://subscription.sub-hub.ai/'
export const BlogLink = 'https://blog.dmail.ai/'
export const ContactLink = 'https://t.me/dmailofficial'
export const RoadMapLink = 'https://dmailnetwork.gitbook.io/dmail-network/overview/roadmap'
export const GitBookLink = 'https://dmailnetwork.gitbook.io/dmail-network/'
export const SubHubLink = 'https://dmailnetwork.gitbook.io/dmail-network/products/marketing-hub'
export const TermsServiceLink = 'https://dmailnetwork.gitbook.io/dmail-network/resources/terms-of-service'
export const PrivacyPolicyLink = 'https://dmailnetwork.gitbook.io/dmail-network/resources/privacy-policy'
export const DmailDocs = 'https://dmailnetwork.gitbook.io/dmail-network/tokenomics/usddmail-tokenomics'
export const PointsDailies = 'https://mail.dmail.ai/events/dailies'
export const BuyDmail = 'https://coinmarketcap.com/currencies/dmail-network/'

// detect the dom is scroll up and can not see in window
export const isUnderTheWindowWhenScrollToUnview = (dom) => {
  try {
    return dom.getBoundingClientRect().top > 0
  } catch (error) {
    
  }
  return false
}

// do something when dom scroll in to view
export const useActionWhenScrollToView = (ref, callback, justPlayOnce = false, hideCallback, ignoreUpOrDown = false) => {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const { target, intersectionRatio } = entry;
      if (intersectionRatio > 0) {
        callback(target)
        justPlayOnce && target && io.unobserve(target)
      } else {
        // do not hide the dom when scroll down and the dom can not see
        if (justPlayOnce || (!isUnderTheWindowWhenScrollToUnview(target) && !ignoreUpOrDown)) {
          return
        }
        typeof hideCallback === 'function' && hideCallback(target)
      }
    })
  })
  const stop = () => {
    ref.current && io.unobserve(ref.current)
    io.disconnect();
  }

  useEffect(() => {
    ref.current && io.observe(ref.current);

    return () => {
      stop()
    }
  }, [])

  return {
    stop
  }
}

export const pagInstance = async (pag, id, width, height) => {
  const PAG = await PAGInit();
  const buffer = await fetch(pag).then((response) => response.arrayBuffer());
  const pagFile = await PAG.PAGFile.load(buffer);
  const canvas = document.getElementById(id);
  canvas.width = width;
  canvas.height = height;
  const pagView = await PAG.PAGView.init(pagFile, canvas);
  return [pagView, async () => {
    return await PAG.PAGView.init(pagFile, canvas)
  }]
}

export const getRandomInInterval = (min, max, isInt = true) => {
  const num = Math.random() * (max - min) + min
  return isInt ? Math.round(num) : num
}

export const whichTransitionEvent = () => {
  const el = document.createElement('div'),
  transitions = {
    'transition':'transitionend',
    'OTransition':'oTransitionEnd',
    'MozTransition':'transitionend',
    'WebkitTransition':'webkitTransitionEnd'
  }

  for(const t in transitions){
    if( el.style[t] !== undefined ){
      return transitions[t];
    }
  }
  return ''
}
  
export const remainDecimalByString = (num, digits = 2) => {
  if (!/^[0-9]+.?[0-9]*$/.test(num + "")) {
    return num;
  }
  const n = Math.pow(10, digits);
  return Math.round(+num * n) / n;
};

export const shortPrincipalId = (principalId, isPid = true) => {
  return principalId.slice(0, isPid ? 9 : 5) + "****" + principalId.slice(isPid ? -6 : -5);
};

export const con = (str, prefix = 5, suffix = 8) => {
  if (!str) return;
  let n = str.split("");
  return n.slice(0, prefix).join("") + "***" + n.slice(-suffix).join("");
};

export const shortHost = link => {
  return link.replace(/\/\/(.*)\.app/, (a, b, c) => {
    return `//${b.substring(0, 5)}...`
  })
}

export const isPrincipalIdFn = (id) => /^([a-z0-9]{5}\-){10}[a-z0-9]{3}$/g.test(id);

export const copyTextToClipboard = (text, successText) => {
  if (!navigator.clipboard) {
    const success = fallbackCopyTextToClipboard(text);
    const msg = success ? successText || "Copy successfully" : "Copy failed";
    Message[success ? "success" : "error"](msg);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function () {
      Message.success(successText || "Copy successfully");
    },
    function (err) {
      Message.error("Copy failed");
    }
  );
};

function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let success = false;
  try {
    const successful = document.execCommand("copy");
    if (successful) {
      success = true;
    }
  } catch (err) {
    success = false;
    console.error("Fallback: Oops, unable to copy", err);
  }

  document.body.removeChild(textArea);
  return success;
}

export function throttle(fn, delay = 150) {
  let timer;
  return function () {
    const _this = this;
    const args = arguments;
    if (timer) {
      return;
    }
    timer = setTimeout(function () {
      fn.apply(_this, args);
      timer = null;
    }, delay)
  }
}

export function debounce(fn, wait = 500) {
  var timeout;
  return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout)
      timeout = setTimeout(function () {
        fn.apply(context, args)
      }, wait);
  };
};

/*
  * 1+2 -> bigNum()(1).plus(2).toNumber() = 3
  * 5-1 -> bigNum()(5).minus(1).toNumber() = 4
  * 6/2 -> bigNum()(6).div(2).toNumber() = 3
  * 6*2 -> bigNum()(6).times(2).toNumber() = 12
  * pow(10, 2);
*/
export const bigNum = (DECIMAL_PLACES = 0) => {
  const num = BigNumber.clone()
  const configs = {}
  if (DECIMAL_PLACES > 0) {
    // DECIMAL_PLACES: { 4: 1/3 => 0.3333,  2: 1/3 => 0.33 }
    configs.DECIMAL_PLACES = DECIMAL_PLACES
  }
  if (Object.keys(configs).length) {
    num.config(configs)
  }
  return num
}

export const remainDecimalByBN = (num, DECIMAL_PLACES = 2, floor = false) => {
  return bigNum(DECIMAL_PLACES)(num).toFixed(2, floor ? 1 : 0)
}
export const formatWithRegex = (number) => {
  return !(number + '').includes('.')
    ? 
      (number + '').replace(/\d{1,3}(?=(\d{3})+$)/g, (match) => {
        return match + ',';
      })
    : (number + '').replace(/\d{1,3}(?=(\d{3})+(\.))/g, (match) => {
        return match + ',';
      });
}

export const firstUpperCase = ([first, ...rest]) => first.toUpperCase() + rest.join('')
